export class MailCenterNotification
{
    public Id: string;
    public DisplayableMessage: string;
    public SubjectTitle: string;
    public CreatedTimeUtc: Date;
    public IsRead: boolean;

    constructor(json: object = null)
    {
        if (json)
        {
            // Map the json object to 'this' objects properties.
            Object.assign(this, json);
        }
    }
}
